var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"total":_vm.total,"editable":_vm.$can(_vm.$permissions.TAG_UPDATE)},on:{"edit":_vm.edit}})}
var staticRenderFns = []

export { render, staticRenderFns }